var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpToLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.656 130.344C194.531 127.219 189.469 127.219 186.344 130.344L34.344 282.344C32.781 283.906 32 285.938 32 288S32.781 292.094 34.344 293.656C37.469 296.781 42.531 296.781 45.656 293.656L184 155.312V472C184 476.406 187.578 480 192 480S200 476.406 200 472V155.312L338.344 293.656C341.469 296.781 346.531 296.781 349.656 293.656S352.781 285.469 349.656 282.344L197.656 130.344ZM376 32H8C3.582 32 0 35.582 0 40S3.582 48 8 48H376C380.418 48 384 44.418 384 40S380.418 32 376 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpToLine);
export default __webpack_public_path__ + "static/media/arrow-up-to-line.3cd8cfcf9cf9b4ffe226f87bb9b4d1e9.svg";
export { ForwardRef as ReactComponent };